import gsap from "gsap";
import { ScrollSpy, Collapse } from "bootstrap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { headerAnimationDataProvider as store } from "./header-animation-data-provider";

const initDestinationNavbar = () => {
  gsap.registerPlugin(ScrollToPlugin);

  const parentEl = document.querySelector("main#main");
  const navbarEl = document.querySelector("#destination-sections-nav-list");
  if (!navbarEl) return;

  // eslint-disable-next-line no-unused-vars
  const scrollSpy = new ScrollSpy(parentEl, {
    target: navbarEl,
    smoothScroll: true,
  });
  let collapse = null;

  const links = parentEl.querySelectorAll("#destination-sections-nav-list a");

  links.forEach((link) => {
    const target = link.getAttribute("href");
    const targetOffset = document.querySelector(target)?.offsetTop ?? 0;

    link.addEventListener("click", (e) => {
      e.preventDefault();
      if (collapse) {
        collapse.hide();
      }

      // Set scroll to active to prevent scroll animation on scroll up
      store.proxyCurrentState.SCROLLTO_ACTIVE = true;

      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: targetOffset - 200,
        },
        onComplete: () => {
          setTimeout(() => {
            store.proxyCurrentState.SCROLLTO_ACTIVE = false;
          }, 300);
        },
      });
    });
  });

  // Collapse
  if (store.isMobile || store.isTablet) {
    const trigger = document.querySelector(".js-destination-sections-nav-mobile-active-item");
    navbarEl.classList.add("collapse");

    collapse = new Collapse(navbarEl, {
      toggle: false,
    });

    let activeItem = navbarEl.querySelector(".active") ?? navbarEl.querySelector("li:first-of-type a");

    trigger.addEventListener("click", () => {
      collapse.toggle();
    });

    navbarEl.addEventListener("shown.bs.collapse", () => {
      // setTimeout(() => {
      ScrollTrigger.update();
      ScrollTrigger.refresh();
      // }, 10);
    });

    navbarEl.addEventListener("hidden.bs.collapse", () => {
      // setTimeout(() => {
      ScrollTrigger.update();
      ScrollTrigger.refresh();
      // }, 10);
    });

    parentEl.addEventListener("activate.bs.scrollspy", (e) => {
      activeItem = e.relatedTarget;
      activeItem.closest("li").classList.add("--is-hidden");

      navbarEl.querySelectorAll("li a:not(.active)").forEach((el) => {
        el.closest("li").classList.remove("--is-hidden");
      });

      document.querySelector(".js-destination-sections-nav-mobile-active-item .js-active-destination-section").innerText =
        activeItem.innerText;
    });
  }
};

export default initDestinationNavbar;
